import { Access, Delegate } from "../../../access/types.ts";
import { GcloudAccesses } from "../gcloud/accesses.ts";

export const WindowsAccesses = {
  account: Access({
    description: "Assume accounts in Microsoft Windows",
    label: "Windows account",
    delegation: {
      "gsm-static": Delegate({
        resource: "gcloud",
        key: "resource" as const,
        accesses: GcloudAccesses,
      }),
    },
    generated: {},
    maturity: "preview",
    parameters: {
      domain: {
        type: "static",
        label: "Domain",
      },
      account: {
        type: "static",
        label: "Account",
      },
    },
    render: { locator: "domain", policy: "account" } as const,
  }),
};

export type WindowsAccesses = typeof WindowsAccesses;
export type WindowsAccountAccess = WindowsAccesses["account"];
